import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIS } from 'src/app/apis';
import { AbstractAuthorizationService } from '../authorization/authorization.abstract.service';
import { PendingPulseCheckData, PulseCheckRequiredData, UserResponsePresentationData } from './responses-data';

@Injectable({
  providedIn: 'root'
})
export abstract class ResponsesAbstractService {

  abstract sendUserResponse (tokenBody: string, score: number): Observable<UserResponsePresentationData>;
  abstract sendTipToSelf (tokenBody: string): Observable<string>;
  abstract getPulseCheckRequiredData(token: string) : Observable<PulseCheckRequiredData>;
  abstract sendPulseResponse (totalEnergy:number, driversScore: Record<string, number>, managerialScore?: number | null) : Observable<string> ;
  abstract sendPulseResponse_noAuth (token: string, totalEnergy:number, driversScore: Record<string, number>, managerialScore?: number | null) : Observable<string> ;

  abstract getPendingPulseCheck(): Observable<PendingPulseCheckData>;
  abstract getSendUserResponseUrl () : string ;
  
}
